<template>
  <v-container>
      <v-layout row wrap>
      <v-flex xs12 sm8 md12>
        <section-header v-text="page.headline"></section-header>
        <div class="subheading justify" v-html="page.description"></div>
        <div class="my-5"></div>
      </v-flex>
    </v-layout>
<v-toolbar color="gray" dense tabs>

      <v-tabs
        slot="extension"
        v-model="currentItem"
        color="transparent"
        fixed-tabs
        slider-color="orange"
      >
        <v-tab v-for="item in items" :href="'#tab-' + item" :key="item">{{ item }}</v-tab>

      </v-tabs>
    </v-toolbar>


   <v-tabs-items v-model="currentItem">
      <v-tab-item value="tab-Credits" >
    <v-container fluid grid-list-xl page>
      <v-layout row wrap>
       <v-flex xs6 md3>   
       <vuse-card-mini-widget    subheader="<strong>AVAILABLE CREDITS</strong>"  
       :headline="currentcredits"
        height="100px"  background="green"
        icon="vpn_key" size="50px"
        iconColor="green">      
       </vuse-card-mini-widget>
       </v-flex>

        <v-flex xs6 md3>   
       <vuse-card-mini-widget    subheader="<strong>USED CREDITOS</strong>"  
       :headline="usedcredits"
        height="100px"  background="black"
        icon="vpn_key" size="50px"
        iconColor="red">      
       </vuse-card-mini-widget>
       </v-flex>

      <v-flex xs6 md3>   
       <vuse-card-mini-widget    subheader="<strong>TOTAL CREDITS</strong>"  
       :headline="totalcredits"
        height="100px"  background="white"
        icon="vpn_key" size="50px"
        iconColor="black">      
       </vuse-card-mini-widget>
       </v-flex>
        </v-layout>
        <div class="my-2">
          <v-btn large color="primary" @click="gotoBuy">Buy Credits</v-btn>
        </div>
    </v-container>
      </v-tab-item>
      <v-tab-item value="tab-Subscriptions" >
        <v-layout row wrap >
        <div>
          Subscriptions
        </div>
        </v-layout>
      </v-tab-item>
      <v-tab-item value="tab-History" >
        <v-layout row wrap >
        <div>
          History
        </div>

        </v-layout>

      </v-tab-item>


      <v-tab-item value="tab-PersonalData" >
  <v-layout row wrap >

    <v-flex xs12>
      <v-container fluid grid-list-xl>
        <v-layout row wrap>
          <section-definition :title="Profile"></section-definition>

          <v-flex xs12 md4>
            <v-text-field
              v-model="userData.firstname"
              :rules="nameRules"
              :counter="50"
              label="Name"
              required
            ></v-text-field>
          </v-flex>

          <v-flex xs12 md4>
            <v-text-field
              v-model="userData.lastname"
              :rules="nameRules"
              :counter="50"
              label="Lastname "
              required
            ></v-text-field>
          </v-flex>

          <v-flex xs12 md4>
            <v-text-field
              v-model="userData.alias"
              :rules="nameRules"
              :counter="40"
              label="Alias"
              required
            ></v-text-field>
          </v-flex>

          <v-flex xs12 md4>
            <v-text-field
              v-model="userData.phone"
              :rules="nameRules"
              :counter="12"
              label="Phone"
              required
            ></v-text-field>
          </v-flex>

          <v-flex xs12 md4>
            <v-text-field
              v-model="userData.address"
              :rules="nameRules"
              :counter="100"
              label="Address"
              required
            ></v-text-field>
          </v-flex>

          <v-flex xs12 md4>
            <v-text-field
              v-model="userData.postalcode"
              :rules="nameRules"
              :counter="10"
              label="Postal Code"
              required
            ></v-text-field>
          </v-flex>

          <v-flex xs12 md4>
            <v-text-field
              v-model="userData.city"
              :rules="nameRules"
              :counter="50"
              label="City"
              required
            ></v-text-field>
          </v-flex>

          <v-flex xs12 md4>
            <v-text-field
              v-model="userData.state"
              :rules="nameRules"
              :counter="50"
              label="State"
              required
            ></v-text-field>
          </v-flex>

          <v-flex xs12 md4>
            <v-text-field
              v-model="userData.country"
              :rules="nameRules"
              :counter="50"
              label="Country"
              required
            ></v-text-field>
          </v-flex>

          <v-flex xs12 md4>
            <v-text-field
              v-model="userData.userEmail"
              :rules="nameRules"
              :counter="100"
              label="E-mail"
              required
              readonly
            ></v-text-field>
          </v-flex>
          <v-flex xs12 md12>
           

            <v-dialog v-model="isSaveUser" persistent max-width="500px">
              <v-btn slot="activator" color="act" dark>Save changes</v-btn>
              <v-card>
                <v-card-title>
                  <span class="headline">Save changes </span>
                </v-card-title>
                <v-card-text>
                  <v-container grid-list-md>
                    <v-layout wrap></v-layout>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="red darken-1" @click.native="isSaveUser = false">Cancel</v-btn>
                  <v-btn color="blue darken-1" @click.native="confirmSave">Save</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-flex>
        </v-layout>
      </v-container>
    </v-flex>
  </v-layout>
  </v-tab-item>
   </v-tabs-items>
  </v-container>
</template>
<script>
export default {
  components: {},
  beforeCreate() {
    window.scrollTo(0, 0);
  },
  mounted() {
    // Google Analytics
    // this.$ga.page(this.$router);
    this.userData = this.$store.getters.userData;
  },
  data() {
    return {
      userData: {},
      isSaveUser: false,
      isDialog: false,
      page: {
        title: "My Profile",
        headline: "My Profile",
        description: `Review and modify your data`
      },
      currentcredits: 0,
      usedcredits: 0,
      totalcredits: 0,
      currentItem: "tab-PersonalData",
      items: ["PersonalData", "Credits", "Subscriptions", "History"],
      more: ["News", "Maps", "Books", "Flights", "Apps"],
      text:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."
    };
  },
  methods: {
    confirmSave() {
      const self = this;
      this.isSaveUser = true;

      const fields = [
        "phone",
        "alias",
        "firstname",
        "lastname",
        "postalcode",
        "state",
        "city",
        "country"
      ];
      fields.forEach(function(propName, index) {
        if (
          self.userData[propName] === null ||
          self.userData[propName] === undefined
        ) {
          self.userData[propName] = "";
        }
      });

      const uuid = this.$store.getters.userUid;
      var docRef = self.$db.collection("users").doc(uuid);

      docRef
        .update({
          phone: self.userData.phone,
          alias: self.userData.alias,
          firstname: self.userData.firstname,
          lastname: self.userData.lastname,
          postalcode: self.userData.postalcode,
          state: self.userData.state,
          city: self.userData.city,
          country: self.userData.country
        })
        .then(function() {
          console.log("Document successfully updated!");
          self.isSaveUser = false;
          self.snacktext = "Your data has been updated";
          self.snackcolor = "success";
          self.snackresult = true;
        })
        .catch(function(error) {
          // The document probably doesn't exist.
          console.error("Error updating data: ", error);
          self.isSaveUser = false;

          self.snacktext = "Error. Your has not been saved";
          self.snackcolor = "red";
          self.snackresult = true;
        });
    },
    gotoBuy() {
      this.$router.push({ name: "PrePayPalPaymentPage" });
    }
  }
};
</script>
